























import Vue from "vue";
import Error from "@/components/basic/Error.vue";
import { DELETE_ERROR } from "@/constants/mutation-types";
import { mapState } from "vuex";

export default Vue.extend({
  name: "Checkbox",
  props: {
    name: String,
    value: {
      type: Boolean,
      // @ts-ignore
      value: false,
    },
    disabled: {
      type: Boolean,
      value: false,
    },
    handlesError: {
      type: Boolean,
      default: true,
    },
    isValidated: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      model: this.value,
      hasError: false as boolean,
      isHighlighted: false as boolean,
    };
  },
  mounted() {
    (this as any).loadData();
  },
  methods: {
    update(): void {
      const t: any = this;

      t.setHighlighted(false);
      t.$store.commit(DELETE_ERROR, t.name);
      t.$emit("input", t.model);
      if ((this as any).isValidated) {
        t.$store.dispatch("validate", {
          name: t.name,
          value: t.model,
        });
      }
     
    },
    loadData(): void {
      if ((this as any).formDataStore.hasOwnProperty((this as any).name)) {
        (this as any).model = (this as any).formDataStore[(this as any).name];
      }
    },
    setHighlighted(value: boolean): void {
      (this as any).isHighlighted = value;
    },
  },
  computed: {
    ...mapState({
      isErrorsChanged(): boolean {
        return this.$store.state.isErrorsChanged;
      },

      formDataStore(): object {
        return this.$store.state.formData;
      },
    }),
  },
  watch: {
    isErrorsChanged(): void {
      (this as any).hasError = (this as any).$store.state.errors.get((this as any).name);
    },
    value(): void {
      (this as any).model = (this as any).value;
    },
    model(): void {
      (this as any).$store.commit(DELETE_ERROR, (this as any).name);
      (this as any).$emit("input", (this as any).model);
    },
  },
  components: {
    Error,
  },
});
